import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import withStyles from '@mui/styles/withStyles';
import cx from 'classnames';

const styles = ({ palette, funeralHome }) => ({
    bucket: {
        borderRadius: 10,
        margin: '8px 0',
        padding: '3px 8px',
        backgroundColor: 'white',
        backgroundImage: `linear-gradient(160deg, ${palette.contentBackground[funeralHome]}33 0%, ${palette.contentBackground[funeralHome]}11 33%, #FFFFFF99 66%, ${palette.contentBackground[funeralHome]}44 100%)`,
        border: '1px solid ' + palette.contentBackground[funeralHome] + 'CC',
        '&:hover, .active': {
            backgroundColor: palette.contentBackground[funeralHome] + '66',
            border: '1px solid ' + palette.contentBackground[funeralHome] + 'AA'
        },
        '& .MuiGrid2-root .inlineField': {
            padding: 0
        }
    },
    container: {
        minWidth: '100%'
    }
});

export default withStyles(styles)(
    ({ pc, children, bucket, style, className, classes, spacing, xs, sm, md, lg, xl, item, container, sx }) => {
        let pcProps;
        if (typeof pc !== 'undefined' || bucket === true) {
            pcProps = {
                // item: true,
                xs: 12,
                sm: Math.floor(12 * (pc || 1))
            };
        }

        if (bucket) {
            pcProps.container = true;
            pcProps.spacing = 2;
            pcProps.component = 'section';
        }

        if (!container && !bucket && !item) {
            xs = 12;
        }

        return (
            <Grid
                style={style}
                className={cx(className, bucket && classes.bucket, container && classes.container)}
                spacing={spacing}
                xs={xs}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                container={container}
                sx={sx}
                {...pcProps}
            >
                {children}
            </Grid>
        );
    }
);
